//配置全局访问接口地址
// let commonUrl = "http://data-center.huayione.com/";

let commonUrl = "https://data-center.huayione.com/";
let baseUrl = {
    commonUrl
}
export default baseUrl